import { render, staticRenderFns } from "./EhpControlComponent.vue?vue&type=template&id=70ab71ab"
import script from "./EhpControlComponent.vue?vue&type=script&lang=js"
export * from "./EhpControlComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports